import { getAllCookies } from './cookies';

export const getGoogleAnalyticsClientId = () => {
	const cookies = getAllCookies();
	return cookies['_ga'] ? cookies['_ga'] : false;
};

const pushDataLayerEvent = (eventData) => {
	if ('event' in eventData) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push(eventData);
	}
};

export const gtmEventRegisterTrial = (trialData) => {
	pushDataLayerEvent({
		event: 'trial_register',
		trial: trialData,
	});
};

// -- Trial Customization --
export const gtmEventCustomizedTrial = ({ selection, trialTemplate }) => {
	pushDataLayerEvent({
		event: 'trial_customized',
		trialCustomization: {
			template: trialTemplate,
			goal: selection[0].value,
			role: selection[1].value,
		},
	});
};

export const gtmEventCustomizationSkipped = (template) => {
	pushDataLayerEvent({
		event: 'trial_customization_skipped',
		trialCustomization: { template },
	});
};
